var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLhqLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3386 550",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448.423 55.6067C446.765 52.7404 443.703 50.9697 440.394 50.9697H192.413C189.097 50.9697 186.036 52.7404 184.385 55.6067L142.284 128.523H333.684C336.242 128.523 338.321 130.601 338.321 133.16V174.217C338.321 176.776 336.242 178.854 333.684 178.854H114.223V177.129L72.2422 249.835H333.676C336.235 249.835 338.313 251.913 338.313 254.472V295.529C338.313 298.088 336.235 300.166 333.676 300.166H72.2422L114.223 372.872V371.146H333.684C336.242 371.146 338.321 373.225 338.321 375.783V416.841C338.321 419.4 336.242 421.478 333.684 421.478H142.284L184.385 494.394C186.043 497.26 189.105 499.031 192.413 499.031H440.394C443.703 499.031 446.772 497.26 448.423 494.394L572.413 279.637C574.072 276.771 574.072 273.23 572.413 270.363L448.423 55.6067Z",
    fill: "url(#paint0_linear_53_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M448.423 55.6067C446.765 52.7404 443.703 50.9697 440.394 50.9697H192.413C189.097 50.9697 186.036 52.7404 184.385 55.6067L142.284 128.523H333.684C336.242 128.523 338.321 130.601 338.321 133.16V174.217C338.321 176.776 336.242 178.854 333.684 178.854H114.223V177.129L72.2422 249.835H333.676C336.235 249.835 338.313 251.913 338.313 254.472V295.529C338.313 298.088 336.235 300.166 333.676 300.166H72.2422L114.223 372.872V371.146H333.684C336.242 371.146 338.321 373.225 338.321 375.783V416.841C338.321 419.4 336.242 421.478 333.684 421.478H142.284L184.385 494.394C186.043 497.26 189.105 499.031 192.413 499.031H440.394C443.703 499.031 446.772 497.26 448.423 494.394L572.413 279.637C574.072 276.771 574.072 273.23 572.413 270.363L448.423 55.6067Z",
    fill: "url(#paint1_linear_53_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M631.27 270.363L477.852 4.63693C476.193 1.77071 473.132 0 469.823 0H162.987C159.678 0 156.609 1.77071 154.959 4.63693L1.54053 270.363C-0.117677 273.229 -0.117677 276.771 1.54053 279.637L154.959 545.363C156.617 548.229 159.678 550 162.987 550H469.823C473.14 550 476.201 548.229 477.852 545.363L631.27 279.637C632.928 276.771 632.928 273.229 631.27 270.363ZM604.543 279.637L599.186 288.911L469.846 512.942L464.488 522.216C462.83 525.082 459.769 526.853 456.46 526.853H176.358C173.041 526.853 169.98 525.082 168.329 522.216L162.972 512.942L33.6242 288.911L28.267 279.637C26.6088 276.771 26.6088 273.229 28.267 270.363L33.6242 261.089L162.972 37.0583L168.329 27.7844C169.988 24.9182 173.049 23.1473 176.358 23.1473H456.46C459.777 23.1473 462.838 24.9182 464.488 27.7844L469.846 37.0583L599.186 261.089L604.543 270.363C606.201 273.229 606.201 276.771 604.543 279.637Z",
    fill: "url(#paint2_linear_53_2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M631.27 270.363L477.852 4.63693C476.193 1.77071 473.132 0 469.823 0H162.987C159.678 0 156.609 1.77071 154.959 4.63693L1.54053 270.363C-0.117677 273.229 -0.117677 276.771 1.54053 279.637L154.959 545.363C156.617 548.229 159.678 550 162.987 550H469.823C473.14 550 476.201 548.229 477.852 545.363L631.27 279.637C632.928 276.771 632.928 273.229 631.27 270.363ZM604.543 279.637L599.186 288.911L469.846 512.942L464.488 522.216C462.83 525.082 459.769 526.853 456.46 526.853H176.358C173.041 526.853 169.98 525.082 168.329 522.216L162.972 512.942L33.6242 288.911L28.267 279.637C26.6088 276.771 26.6088 273.229 28.267 270.363L33.6242 261.089L162.972 37.0583L168.329 27.7844C169.988 24.9182 173.049 23.1473 176.358 23.1473H456.46C459.777 23.1473 462.838 24.9182 464.488 27.7844L469.846 37.0583L599.186 261.089L604.543 270.363C606.201 273.229 606.201 276.771 604.543 279.637Z",
    fill: "url(#paint3_linear_53_2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1995.67 442.084V107.917H2047.27L2198.58 407.014H2199.58V107.917H2232.14V442.084H2180.54L2029.24 142.987H2028.24V442.084H1995.67Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1695.41 331.363V218.638C1695.41 169.54 1702.92 141.484 1720.96 125.452C1737.49 110.422 1764.54 104.41 1814.14 104.41C1867.75 104.41 1894.8 111.424 1911.34 129.46C1926.37 145.993 1932.88 174.049 1932.88 218.638V331.363C1932.88 380.461 1924.86 408.517 1906.83 424.549C1890.3 439.579 1863.74 445.591 1813.64 445.591C1718.95 445.591 1695.41 423.046 1695.41 331.363ZM1900.32 329.359V220.642C1900.32 145.993 1890.3 136.474 1814.14 136.474C1737.99 136.474 1727.97 145.993 1727.97 220.642V329.359C1727.97 404.008 1737.99 413.527 1814.14 413.527C1890.3 413.527 1900.32 404.008 1900.32 329.359Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1594.19 442.084V107.917H1626.75V442.084H1594.19Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1406.92 309.82V277.756H1527.16V352.405C1527.16 389.98 1520.14 414.028 1504.61 427.555C1490.08 440.581 1467.04 445.591 1418.94 445.591C1361.33 445.591 1334.27 439.078 1317.74 420.04C1302.71 404.008 1296.2 375.952 1296.2 330.862V218.638C1296.2 169.54 1303.71 141.484 1321.75 125.452C1338.78 110.422 1365.33 104.41 1416.94 104.41C1454.51 104.41 1477.06 107.416 1493.09 113.929C1516.13 123.448 1527.16 142.486 1527.16 173.047V206.614H1494.59V194.59C1494.59 144.49 1484.07 136.474 1415.93 136.474C1338.78 136.474 1328.76 145.993 1328.76 220.642V329.359C1328.76 405.01 1337.78 413.026 1421.45 413.026C1486.58 413.026 1494.59 405.511 1494.59 342.886V309.82H1406.92Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M832.516 442.084V107.917H865.081V410.02H1007.36V442.084H832.516Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.95 108.083H1238.95V140.083H1057.95V108.083Z",
    fill: "url(#paint4_linear_53_2)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.95 108.083H1238.95V140.083H1057.95V108.083Z",
    fill: "url(#paint5_linear_53_2)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.95 259.083H1238.95V291.083H1057.95V259.083Z",
    fill: "url(#paint6_linear_53_2)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.95 259.083H1238.95V291.083H1057.95V259.083Z",
    fill: "url(#paint7_linear_53_2)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.95 410.083H1238.95V442.083H1057.95V410.083Z",
    fill: "url(#paint8_linear_53_2)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.95 410.083H1238.95V442.083H1057.95V410.083Z",
    fill: "url(#paint9_linear_53_2)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3385.72 389.98V442.084H3133.21V372.445C3134.21 303.307 3151.75 287.275 3241.93 273.748C3322.09 259.72 3323.59 258.718 3323.59 209.119C3323.59 165.031 3314.57 157.516 3260.47 157.516C3202.85 157.516 3195.33 164.029 3195.33 212.626V225.652H3134.21C3134.71 172.045 3136.22 160.522 3146.24 142.987C3162.27 115.933 3194.83 104.911 3261.97 104.911C3357.66 104.911 3385.72 128.959 3385.72 211.624C3385.72 256.213 3377.7 279.259 3357.66 294.79C3343.63 305.812 3324.09 311.824 3273.99 320.842C3198.34 332.866 3196.34 334.87 3195.84 380.962L3195.33 389.98H3385.72Z",
    fill: "url(#paint10_linear_53_2)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3385.72 389.98V442.084H3133.21V372.445C3134.21 303.307 3151.75 287.275 3241.93 273.748C3322.09 259.72 3323.59 258.718 3323.59 209.119C3323.59 165.031 3314.57 157.516 3260.47 157.516C3202.85 157.516 3195.33 164.029 3195.33 212.626V225.652H3134.21C3134.71 172.045 3136.22 160.522 3146.24 142.987C3162.27 115.933 3194.83 104.911 3261.97 104.911C3357.66 104.911 3385.72 128.959 3385.72 211.624C3385.72 256.213 3377.7 279.259 3357.66 294.79C3343.63 305.812 3324.09 311.824 3273.99 320.842C3198.34 332.866 3196.34 334.87 3195.84 380.962L3195.33 389.98H3385.72Z",
    fill: "url(#paint11_linear_53_2)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3099.28 397.495L3073.23 435.571L3041.17 413.527C3017.62 438.076 2990.57 445.09 2923.93 445.09C2850.79 445.09 2820.73 437.575 2799.69 412.525C2778.14 387.976 2773.13 362.926 2773.13 285.772C2773.13 197.596 2776.64 173.548 2792.17 148.498C2805.2 128.959 2826.74 114.931 2854.29 109.42C2867.82 106.414 2893.87 104.911 2924.94 104.911C2972.03 104.911 2995.58 107.917 3014.11 115.933C3044.17 129.46 3061.21 153.508 3067.72 192.586C3070.23 207.616 3071.23 227.656 3071.23 275.251C3071.23 335.371 3070.23 350.902 3064.71 373.447L3099.28 397.495ZM2909.4 323.347L2935.46 284.77L3004.59 331.864C3005.6 319.84 3006.1 312.325 3006.1 307.816V273.748C3006.1 218.137 3006.1 218.137 3003.59 203.107C3000.59 183.568 2993.07 171.043 2980.05 165.532C2969.02 161.023 2956.5 160.021 2918.92 160.021C2878.34 160.021 2864.82 162.526 2854.29 173.047C2843.27 183.568 2838.76 201.103 2838.26 234.169V289.279C2838.26 336.874 2839.77 349.9 2845.78 365.431C2854.29 385.972 2867.32 389.98 2932.45 389.98C2963.01 389.98 2970.03 387.976 2987.06 375.952L2909.4 323.347Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2715.21 107.917V442.084H2651.09V299.299H2496.28V442.084H2432.15V107.917H2496.28V244.69H2651.09V107.917H2715.21Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_53_2",
    x1: 82.3093,
    y1: 212.272,
    x2: 556.74,
    y2: 339.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#534DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A9DE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_53_2",
    x1: 82.3093,
    y1: 212.272,
    x2: 556.74,
    y2: 339.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A64FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39AEF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_53_2",
    x1: 12.9901,
    y1: 198,
    x2: 608.984,
    y2: 362.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#534DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A9DE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_53_2",
    x1: 12.9901,
    y1: 198,
    x2: 608.984,
    y2: 362.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A64FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39AEF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_53_2",
    x1: 1061.59,
    y1: 228.323,
    x2: 1242.1,
    y2: 251.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#534DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A9DE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_53_2",
    x1: 1061.59,
    y1: 228.323,
    x2: 1242.1,
    y2: 251.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A64FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39AEF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_53_2",
    x1: 1061.59,
    y1: 228.323,
    x2: 1242.1,
    y2: 251.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#534DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A9DE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_53_2",
    x1: 1061.59,
    y1: 228.323,
    x2: 1242.1,
    y2: 251.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A64FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39AEF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_53_2",
    x1: 1061.59,
    y1: 228.323,
    x2: 1242.1,
    y2: 251.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#534DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A9DE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_53_2",
    x1: 1061.59,
    y1: 228.323,
    x2: 1242.1,
    y2: 251.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A64FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39AEF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_53_2",
    x1: 3138.28,
    y1: 226.293,
    x2: 3386.37,
    y2: 270.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#534DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A9DE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_53_2",
    x1: 3138.28,
    y1: 226.293,
    x2: 3386.37,
    y2: 270.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A64FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39AEF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLhqLogoDark);
export default __webpack_public_path__ + "static/media/lhqLogoDark.eef3017fcce150ce51718a56489a9bc6.svg";
export { ForwardRef as ReactComponent };